// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__KI6CF","inlineCheckbox":"Checkbox_inlineCheckbox__4YHUm"};